<template>
  <div class="about-us">
    <div class="banner-wrap">
      <img class="about-banner" src="../../assets/images/about_banner.jpg" alt="">
    </div>
    <!-- 简介 -->
    <div class="introduce" id="introduce">
      <Title title="企业简介"></Title>
      <div class="introduce-content">
        <p>我们成立于2001年，以先进的教育理念为指导，以优质的教育教学为依托，专注于探索信息技术与教育教学的深度融合，为全国中小学校提供课堂模式改革和应用、教师专业发展、教研能力创新、优质教育共享、学生全面发展的全过程智慧教育解决方案，是一个拥有深厚教育底蕴的教育科技品牌。</p>
        <p>自创立以来，始终围绕“让更多的孩子得到更好的教育”使命，已为全国多地教育主管部门、4000多所学校提供了全过程智慧教育解决方案，累计30多万教师、300多万学生受益，为推动中国教育的优质均衡发展、教学质量提升及教师专业发展贡献了力量。</p>
      </div>
    </div>
    <!-- 联系 -->
    <div class="connect" id="connect">
      <Title title="联系方式"></Title>
      <div class="connect-wrap">
        <img class="connect-img" src="../../assets/images/about_img.png" alt="">
        <div class="connect-content">
          <div class="connect-item">
            <img src="../../assets/images/support_phone.png" alt="">
            <div class="connect-item-title">
              <p>商务合作:</p>
              <p class="connect-item-content">400-061-6167</p>
            </div>
          </div>
          <div class="connect-item" style="margin-top:90px;">
            <img src="../../assets/images/email.png" alt="">
            <div class="connect-item-title">
              <span>媒体合作:</span>
              <p class="connect-item-content">010-82025511</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Title from './components/ModuleTitle.vue'
export default {
  mounted() {
    if (this.$route.query.id) {
      let id  = this.$route.query.id
      let scrollDom = document.getElementById(id)
      document.documentElement.scrollTop = document.body.scrollTop = scrollDom.offsetTop - 80
    }
  },
  components: {
    Title
  }
}
</script>
<style lang="scss" scoped>
.about-us {
  .banner-wrap {
    width: 100%;
    .about-banner {
      width: 100%;
      // height: 568px;
      display: block;
    }
  }
  .introduce {
    margin-top: 136px;
    &-content {
      width: 902px;
      font-size: 22px;
      font-weight: 400;
      color: #595757;
      line-height: 40px;
      margin: 0 auto;
      margin-top: 42px;
      p {
        text-indent: 2em;
      }
    }
  }
  .connect {
    margin-top: 224px;
    margin-bottom: 230px;
    text-align: center;
    .connect-wrap {
      display: flex;
      justify-content: center;
      margin-top: 60px;
      .connect-img {
        width: 604px;
        height: 470px;
      }
      .connect-content {
        width: 525px;
        height: 470px;
        box-sizing: border-box;
        background: #fff;
        box-shadow: 0px 11px 70px 0px rgba(222, 227, 231, 0.35);
        padding: 108px 40px 136px 48px;
        .connect-item {
          display: flex;
          font-weight: 500;
          color: #595757;
          font-size: 30px;
          text-align: left;
          img {
            width: 46px;
            height: 46px;
            margin-right: 16px;
          }
          .connect-item-content {
            font-size: 26px;
            font-weight: 400;
            line-height: 26px;
          }
        }
      }
    }
  }
}
</style>